import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Commands, Results } from '@local/client-contracts';
import { STYLE_SERVICE, UiIconModel } from '@local/ui-infra';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { StyleService } from '@shared/services/style.service';
import { getIconModel } from '@shared/utils/set-icon.util';
import { hasDropdown } from '@shared/utils/utils';
import { DropdownComponent } from 'src/app/bar/components';
import { Intent } from '../../../hub/shared/model';

@UntilDestroy()
@Component({
  selector: 'result-badge',
  templateUrl: './result-badge.component.html',
  styleUrls: ['./result-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultBadgeComponent implements OnInit {
  private _model: Results.Badge;
  @Input() set model(value: Results.Badge) {
    this._model = value;
    const icon = this.model?.icon;
    this.iconModel = getIconModel(icon);
    this.cdr.markForCheck();
  }
  @Output() invoke = new EventEmitter<Commands.Command>();
  @Input() intent: Intent;

  iconModel: UiIconModel;

  @HostBinding('class.clickable')
  get clickable(): boolean {
    return this.model && (this.model.onClick != null || hasDropdown(this.model));
  }

  @ViewChild('dropdown') dropdown: DropdownComponent;

  get hasDropdown(): boolean {
    return hasDropdown(this.model);
  }
  get model(): Results.Badge {
    return this._model;
  }
  theme: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private elementRef: ElementRef,
    @Inject(STYLE_SERVICE) private styleService: StyleService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const icon = this.model?.icon;
    this.iconModel = getIconModel(icon);
    this.theme = 'light';
    this.cdr.markForCheck();
    if (this.model.backgroundColor?.darkTheme || this.model.textColor?.darkTheme) {
      this.styleService.theme$.pipe(untilDestroyed(this)).subscribe((theme: any) => {
        this.theme = theme;
        this.cdr.markForCheck();
      });
    }
  }

  @HostListener('click')
  onClick(): void {
    if (this.hasDropdown) {
      this.openDropdown();
      return;
    }

    this.sendCommand(this.model.onClick);
  }

  @HostListener('contextmenu')
  onRightClick(): void {
    this.sendCommand(this.model.onRightClick);
  }

  sendCommand(command: Commands.Command): void {
    if (!command) {
      return;
    }

    this.invoke.emit(command);
  }

  private openDropdown(): void {
    this.dropdown.open(this.elementRef, this.viewContainerRef);
  }

  get computedClass() {
    return {
      ['has-icon']: this.model.icon,
      ['had-dropdown']: this.hasDropdown,
      [this.intent]: this.intent,
    };
  }
}
